import axios from 'axios';

import { env } from 'config/environmentConfig';

export const instance = axios.create({
	baseURL: env.API_ENDPOINT_URL,
	timeout: 60000
});
